export default (theme) => {
  return !!theme?.preziTheme;
}
